import domready from "domready"
import AdaptiveLinearization from "adaptive-linearization"
import "./style.css"
import weightedRandom from "./weightedRandom";
import Color from "./Color";

const PHI = (1 + Math.sqrt(5)) / 2;
const TAU = Math.PI * 2;
const DEG2RAD_FACTOR = TAU / 360;

const config = {
    width: 0,
    height: 0
};

/**
 * @type CanvasRenderingContext2D
 */
let ctx;
let canvas;



const harmonies = [0.5, 1/6, 1/3,2/3,5/6]

function norm(number)
{
    const n = number - (number | 0);
    return n < 0 ? 1 + n : n;
}

function randomAlpha()
{
    let rnd = Math.random();
    return 0.5 + (rnd * rnd ) * 0.5

}

domready(
    () => {

        canvas = document.getElementById("screen");
        ctx = canvas.getContext("2d");

        const width = (window.innerWidth) | 0;
        const height = (window.innerHeight) | 0;

        config.width = width;
        config.height = height;

        canvas.width = width;
        canvas.height = height;



        const drawLine = (x0, y0, x1, y1, spread = 300, count = 30) => {
            let dx = (x1 - x0)
            let dy = (y1 - y0)
            const len = Math.sqrt(dx * dx + dy * dy)

            dx /= len;
            dy /= len;

            const pow = 0.5 + Math.random() * 2.5

            for (let i=0; i < count; i++)
            {
                const sig = Math.random() < 0.5 ? -1 : 1;
                const rnd = Math.random();
                const d = sig * Math.pow(rnd, pow) * spread
                const ox = dy * d;
                const oy = -dx * d;
                const drawOff = -0.5 + Math.random() * 0.5 * len
                const drawLen = drawOff + ( 0.1 + Math.random() * 5 - rnd * 4) * len

                ctx.lineWidth = 0 |(1 + Math.random() * 4);
                ctx.strokeStyle = config.randomColor()
                ctx.beginPath()
                ctx.moveTo(0|(x0 + dx * drawOff + ox),0|(y0 + dy* drawOff + oy))
                ctx.lineTo(0|(x0 + dx * drawLen + ox),0|(y0 + dy * drawLen + oy))
                ctx.stroke()
            }

        };


        const clear = () => {
            const hue = Math.random();
            const h = harmonies[0|Math.random() * harmonies.length];

            config.randomColor = weightedRandom([
                1, () => Color.from("#fff").toRGBA(randomAlpha()),
                1, () => Color.fromHSL(hue, 1, 0.5).toRGBA(randomAlpha()),
                1, () => Color.fromHSL(norm(hue+ h), 1, 0.5).toRGBA(randomAlpha())
            ])

            ctx.fillStyle = "#000";
            ctx.fillRect(0, 0, width, height);
        }
        const draw = (spread = 300, count = 30) => {


            let prevX = -1, prevY = -1;
            const al = new AdaptiveLinearization((x0, y0, x1, y1, data) => {

                if (prevX > 0)
                {
                    drawLine(prevX, prevY, x0, y0, spread)
                }
                drawLine(x0, y0, x1, y1, spread, count)

                prevX = x1
                prevY = y1

            }, {
                approximationScale: 1,
                maxLine: 4
            })

            ctx.strokeStyle = "#fff"
            let xOff = 0 | (-width * 0.45 / 4 + Math.random() * width * 0.9);
            let yOff = 0 | (-height / 2 + Math.random() * height);
            al.linearize(
                0, 0 | Math.random() * height,
                width / 2 + xOff, height / 2 - yOff,
                width / 2 - xOff, height / 2 + yOff,
                width, 0 | Math.random() * height
            )
        };

        const paint = () => {
            clear();
            draw(200 + Math.random() * 200, 30);
        }
        paint()


        window.addEventListener("click" ,paint, true)

    }
);
